var _defs, _circle, _path, _path2, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C084FC",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#E9D5FF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7E22CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5B21B6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headShadow",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodColor: "#7E22CE",
    floodOpacity: 0.08
  })), /*#__PURE__*/React.createElement("filter", {
    id: "badgeShadow",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 10,
    floodColor: "#7E22CE",
    floodOpacity: 0.06
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 140,
    fill: "url(#bgGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 85 Q70 50 40 50 Q70 50 70 15 Q70 50 100 50 Q70 50 70 85 Z",
    fill: "#E9D5FF",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 150 Q25 140 15 140 Q25 140 25 130 Q25 140 35 140 Q25 140 25 150 Z",
    fill: "#F3E8FF",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350 180 Q350 170 340 170 Q350 170 350 160 Q350 170 360 170 Q350 170 350 180 Z",
    fill: "#F3E8FF",
    opacity: 0.95
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 42)",
    filter: "url(#badgeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 75,
    rx: 22,
    fill: "#FAF5FF",
    stroke: "#F3E8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26, 17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 40,
    rx: 9,
    stroke: "#7E22CE",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 32 L19 16 L29 27 L34 21 L41 32 Z",
    fill: "none",
    stroke: "#7E22CE",
    strokeWidth: 3.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 12,
    r: 3,
    fill: "#7E22CE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 14,
    width: 8,
    height: 18,
    rx: 4,
    fill: "#A855F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 10,
    r: 10,
    fill: "#A855F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87,
    width: 22,
    height: 42,
    rx: 11,
    fill: "#A855F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 87,
    width: 22,
    height: 42,
    rx: 11,
    fill: "#A855F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 180,
    height: 155,
    rx: 77.5,
    fill: "#FBF8FF",
    filter: "url(#headShadow)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 58,
    width: 126,
    height: 98,
    rx: 49,
    fill: "url(#faceGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 107,
    r: 10.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 107,
    r: 10.5,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesCreateIcon);
export default __webpack_public_path__ + "static/media/images-create-icon.0a4028687088bce11eeaca561f6a613f.svg";
export { ForwardRef as ReactComponent };